import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Reports from './pages/Reports';
import Calculator from './pages/Calculator';
import Login from './pages/Login';
import SelfService from './pages/SelfService';
import { getSession, signOut } from './auth';
import './App.css';

function App() {
  const [userEmail, setUserEmail] = useState(null);
  const [checking, setChecking] = useState(true);

  const isPublicPath = window.location.pathname.startsWith('/try');

  useEffect(() => {
    if (isPublicPath) {
      setChecking(false);
      return;
    }
    getSession()
      .then((session) => setUserEmail(session.getIdToken().payload.email))
      .catch(() => setUserEmail(null))
      .finally(() => setChecking(false));
  }, [isPublicPath]);

  const handleLogin = () => {
    getSession()
      .then((session) => setUserEmail(session.getIdToken().payload.email))
      .catch(() => setUserEmail(null));
  };

  const handleSignOut = () => {
    signOut();
    setUserEmail(null);
  };

  const selfServiceEnabled = process.env.REACT_APP_SELF_SERVICE_ENABLED !== 'false';

  if (isPublicPath) return (
    <Router>
      <Routes>
        <Route path="/try" element={
          selfServiceEnabled
            ? <SelfService />
            : <div style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>Portal Unavailable</h2>
                <p>The self-service portal is not currently available.</p>
              </div>
        } />
      </Routes>
    </Router>
  );

  if (checking) return null;
  if (!userEmail) return <Login onLogin={handleLogin} />;

  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="navbar-container">
            <div className="logo">
              <img src="/logo-navbar.png" alt="" className="navbar-logo-img" aria-hidden="true" />
              <span>AWS EUC Pre-Flight Inspection</span>
            </div>
            <div className="nav-links">
              <Link to="/">Dashboard</Link>
              <Link to="/calculator">Estimator</Link>
              <Link to="/customers">Customers</Link>
              <Link to="/reports">Reports</Link>
              <span className="user-info">{userEmail}</span>
              <button onClick={handleSignOut} className="btn-signout">Sign Out</button>
            </div>
          </div>
        </nav>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/reports" element={<Reports />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
